import Vue from 'vue'
// pinia 必须最先创建：App.vue 及其依赖的布局组件在模块顶层调用 useXxxStore()，
// 依赖 pinia 的全局激活实例，导入顺序晚于它们会导致 "Cannot read properties of undefined (reading '_s')"
import pinia from '@/store'
import App from './App.vue'
import router from './router'
import { api, mixAuthApi, expertApi, examApi } from '@/api'
import { PiniaVuePlugin } from 'pinia'
import './filter'
import './utils/antd'
import './directives'
import { registerMicroApps, start, initGlobalState, MicroAppStateActions, setDefaultMountApp } from 'qiankun'
import { ls, useTokenStore } from '@/store/token'
import { useUserStore } from '@/store/user'
import { apps, excludeAssetFilter, openCustomerService, state } from '../micro/config'
import { GlobalActions } from '../../../enums/globa'
import { HALL_ACTIVE_RULE } from '../../../micro/micro-config'
import { useMenuStore } from '@/store/menu'
import { useClientStore } from '@/store/client'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useMixAuthStore } from '@/store/mix-auth'
import { getFileDownloadToken } from './utils/file-token'

const userStore = useUserStore(pinia)
const tokenStore = useTokenStore(pinia)
const menuStore = useMenuStore(pinia)
const clientStore = useClientStore(pinia)
const reuseTabStore = useReuseTabStore(pinia)
const mixAuthStore = useMixAuthStore(pinia)

;(async () => {
  // 预获取文件下载 Token（失败不影响主流程，但确保 token 就绪后再启动 qiankun）
  try {
    await getFileDownloadToken()
  } catch (e) {
    console.warn('[main-micro] 获取文件下载 Token 失败', e)
  }

  registerMicroApps(apps)
  setDefaultMountApp(HALL_ACTIVE_RULE)
  //启动qiankun
  start({
    excludeAssetFilter,
  })
})()
const log = (...info) => {
  console.log('%c[main-micro]', 'color: #fff;background-color:#108ee9; padding: 2px;', ...info)
}

// 初始化 state
const actions: MicroAppStateActions = initGlobalState(state)
actions.onGlobalStateChange((state) => {
  log('onGlobalStateChange:', state)
  switch (state.action) {
    case GlobalActions.SignOut:
      log('SignOut')
      ls.clear()
      userStore.logout()
      menuStore.clear()
      clientStore.reset()
      mixAuthStore.clear()
      window.history.pushState(null, '', '/hall')
      break
    case GlobalActions.SignIn:
      log('SignIn')
      tokenStore.setToken(state.token)
      userStore.setUserInfo(state.userInfo)
      userStore.logged()
      break
    case GlobalActions.InitMenu:
      menuStore.init({
        menus: state.menus,
        buttons: state.buttons,
      })
      break
    case GlobalActions.SetClient:
      clientStore.setClientInfo({
        clients: state.clients,
        currentClient: state.currentClient,
      })
      menuStore.init({
        menus: state.menus,
        originalMenus: state.originalMenus,
        buttons: state.buttons,
      })
      break
    case GlobalActions.SetMixAuth:
      mixAuthStore.init({
        mixAuthUserName: state.mixAuthUserName,
        mixAuthToken: state.mixAuthToken,
        mixAuthModules: state.mixAuthModules,
      })
      break
  }
})

Vue.config.productionTip = false
Vue.prototype.$http = api
Vue.prototype.$mixAuthApi = mixAuthApi
Vue.prototype.$expertHttp = expertApi
Vue.prototype.$examHttp = examApi
Vue.prototype.$setGlobalState = actions.setGlobalState
Vue.prototype.$openCustomerService = openCustomerService
Vue.use(PiniaVuePlugin)

new Vue({
  router,
  render: (h) => h(App),
  pinia,
}).$mount('#root')
